// extracted by mini-css-extract-plugin
export default {"items":"return_items__+AA1A","item":"return_item__PpNbX","buttons":"return_buttons__1+fuv"};